// @flow
import _ from 'lodash';

import AppDispatcher from 'PMT/flux/AppDispatcher';
import PMTApiUser from 'PMT/api/ApiUser';

import ActionTypes from 'constants/ActionTypes';

import ApiError from 'PMT/entities/ApiError';
import User from 'PMT/entities/user/User';

export default class UserAction {

  //
  // load user
  //

  static loadUser(userId: string) {
    PMTApiUser.getUser(
      userId,
      UserAction.receiveUser,
      UserAction.receiveUserError
    );
  }

  static receiveUser(user: User) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_USER_RESPONSE_SUCCESS,
      user: user
    });
  }

  static receiveUserError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_USER_RESPONSE_FAILURE,
      apiError: apiError
    });
  }

  //
  // load user for payment
  // TODO: Use another ActionTypes: GET_USER_FOR_PAYMENT...
  //

  static loadUserForPayment(userId: string, paymentId: string) {
    PMTApiUser.getUserForPayment(
      userId,
      paymentId,
      UserAction.receiveUserForPayment,
      UserAction.receiveUserForPaymentError
    );
  }

  //
  // load user for review
  // TODO: Use another ActionTypes: GET_USER_FOR_PAYMENT...
  //

  static loadUserForReview(userId: string, reviewId: string) {
    PMTApiUser.getUserForReview(
      userId,
      reviewId,
      UserAction.receiveUserForPayment,
      UserAction.receiveUserForPaymentError
    );
  }

  static receiveUserForPayment(user: User) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_USER_RESPONSE_SUCCESS,
      user: user
    });
  }

  static receiveUserForPaymentError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_USER_RESPONSE_FAILURE,
      apiError: apiError
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/actions/UserAction.js